export default "__VITE_ASSET__CeX_ZMb3__"